import { nanoid } from "@reduxjs/toolkit";

import {
  NOTIFICATION_POSITIONS,
  NOTIFICATION_TIMEOUT,
  NOTIFICATION_GROUPS,
} from "../constants";
import { actions } from "store/notification";

export const {
  notificationAdd,
  notificationDelete,
  setNotificationProjectFolder,
} = actions;

export const notificationDisplay =
  (
    type,
    messages,
    group = NOTIFICATION_GROUPS.general,
    position = [NOTIFICATION_POSITIONS.bottom]
  ) =>
  (dispatch) => {
    const id = nanoid();
    dispatch(notificationAdd({ id, type, messages, position, group }));
    setTimeout(
      () => dispatch(notificationDelete({ id, group })),
      group === NOTIFICATION_GROUPS.consversionResult
        ? NOTIFICATION_TIMEOUT / 2
        : NOTIFICATION_TIMEOUT
    );
  };
